import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import Slider from 'react-slick'

export default function Album( data ) {
  return (
    <div className="album">
      <h2 className="intertitre">Galerie photo</h2>
      <Slider infinite={true} slidesToShow={1} arrows>
        {data.slides.edges.map(({ node }) => (
          <Img fluid={ node.childImageSharp.fluid } key={node.id} />
        ))}
      </Slider>
    </div>
  )
}
